module.exports = __webpack_public_path__ + "img/tw.9afa5d26.svg";